import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=64cbe540&scoped=true&"
import script from "./Login.vue?vue&type=script&lang=js&"
export * from "./Login.vue?vue&type=script&lang=js&"
import style0 from "./Login.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Login.vue?vue&type=style&index=1&id=64cbe540&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cbe540",
  null
  
)

export default component.exports